export const yyyy_MM_dd = "yyyy-MM-dd";
export const hh_mm_ss = "yyyy-MM-dd hh:mm:ss";
export const yyyy_MM_dd_hh_mm_ss = "yyyy-MM-dd hh:mm:ss";
export const hh_mm = "hh:mm";

/**
 * 格式化日期
 * @param {String|Date} date 日期时间
 * @param {String} fmt  格式化格式
 */
export const format = (date, fmt) => {
  if (!date) {
    return ''
  }

  date = new Date(date)

  var o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    "S": date.getMilliseconds()
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.toString().replace(RegExp.$1, (date.getFullYear() + "")
      .substring(4 - RegExp.$1.length))
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      // eslint-disable-next-line
      fmt = fmt.toString().replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k])
        : (("00" + o[k]).substring(("" + o[k]).length)))
    }
  }

  return fmt
};


/**
 * 使用yyyy_MM_dd进行格式化
 * @param date 时间
 */
export const formatYMD = date => format(date, yyyy_MM_dd);

/**
 * 格式化日期
 * @param date 时间
 */
export const formatDate = date => formatYMD(date);

/**
 * 格式化时间
 * @param date 时间
 */
export const formatTime = date => format(date, hh_mm_ss);

/**
 * 格式化日期时间
 * @param date 时间
 */
export const formatDateTime = date => format(date, yyyy_MM_dd_hh_mm_ss);

/**
 * 使用hh_mm进行格式化
 * @param date 时间
 */
export const formatHM = date => format(date, hh_mm);
